/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Page, Document, StyleSheet } from '@react-pdf/renderer';
import { PDFViewerHeading } from './PDFHeading';
import XPDFViewer from './XPDFViewer';
import PDFTable from './PDFTable';
import { PDFInvoiceHeader } from './PDFInvoiceHeader';

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    lineHeight: 1.5,
    color: '#3E4B5B',
    flexDirection: 'column',
  },
});

function XPDF(props: any) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {props.children}
      </Page>
    </Document>
  );
}

XPDF.Preview = XPDFViewer;
XPDF.Header = PDFViewerHeading;
XPDF.Table = PDFTable;
XPDF.InvoiceHeader = PDFInvoiceHeader;

export default XPDF;
